<div class="flex flex-col h-full bg-gray-100 w-full max-w-[950px] mx-auto px-6 py-4">

    <!-- Navigation haut -->
    <div class="flex justify-between items-center mb-4">
        <button (click)="$event.stopPropagation(); onGoBack()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-left text-lg"></i>
        </button>
        @if (!isLastStep()) {
        <button (click)="$event.stopPropagation(); onGoForward()" [disabled]="!canNext()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-right text-lg"></i>
        </button>
        }
    </div>

    <!-- Contenu spécifique projeté par le composant enfant -->
    <ng-content></ng-content>

    <!-- Badge renderer (caché) -->
    @if (badgeTemplate) {
    <app-badge-renderer style="display: none;"
        [template]="badgeTemplate"
        [data]="badgeData"
        [width]="400"
        [height]="250"
        (imageGenerated)="onBadgeImageReady($event)">
    </app-badge-renderer>
    }

    <!-- Footer navigation -->
    <div class="flex justify-between items-center mt-8">
        <button (click)="$event.stopPropagation(); onGoBack()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-left text-lg"></i>
        </button>
        <button (click)="onGoHome()" class="flex items-center gap-2 text-gray-700">
            <i class="fas fa-home text-2xl"></i>
            <span>{{ 'vues.ipad.nav.home' | translate }}</span>
        </button>

        @if (isLastStep()) {
        <!-- Dernière étape : Accepter / Refuser -->
        <div class="flex gap-3">
            <button (click)="onGoHome()"
                class="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-sm shadow font-semibold">
                {{ 'vues.ipad.checkin.reject' | translate }}
            </button>
            <button (click)="onSave()" [disabled]="!canNext()"
                class="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-sm shadow font-semibold disabled:opacity-50 disabled:cursor-not-allowed">
                {{ 'vues.ipad.checkin.accept' | translate }}
            </button>
        </div>
        } @else {
        <!-- Steps intermédiaires : bouton suivant -->
        <button (click)="$event.stopPropagation(); onGoForward()" [disabled]="!canNext()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-right text-lg"></i>
        </button>
        }
    </div>

</div>